import React from "react";
import PropTypes from "prop-types";
import "./InfoModal.scss";
import { Cancel, Globe } from "../../constants/icons/Icons";

const InfoModal = ({ isOpen, onClose, data, handleInfoClick }) => {
  if (!isOpen) return null;

  const handleGlobeClick = () => {
    handleInfoClick("EN");
  };

  return (
    <div
      className="info-modal-overlay"
      role="dialog"
      aria-labelledby="info-modal-title"
      aria-describedby="info-modal-description"
      aria-modal="true"
    >
      <div className="info-modal">
        <div className="info-modal-header">
          <div className="info-modal-top-row">
            <span className="kba-code" aria-label={`KBA Code: ${data.kbaCode}`}>
              {data.kbaCode}
            </span>
            <div className="info-modal-lang">
              <span className="language-code" aria-label={`Language Code: ${data.languageCode}`}>
                {data.languageCode}
              </span>
              <div
                className="globe-icon"
                onClick={handleGlobeClick}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleGlobeClick();
                  }
                }}
                tabIndex="0"
                role="button"
                aria-label="Change language to English"
              >
                <Globe />
              </div>
            </div>
          </div>
          <h2 id="info-modal-title" className="info-modal-title">
            {data.title}
          </h2>
          <button
            className="info-cancel-button"
            onClick={onClose}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                onClose();
              }
            }}
            aria-label="Close modal"
          >
            <Cancel />
          </button>
        </div>
        <div id="info-modal-description" className="info-modal-content">
          <p>{data.description}</p>
        </div>
      </div>
    </div>
  );
};

InfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.shape({
    kbaCode: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    languageCode: PropTypes.string,
  }).isRequired,
  handleInfoClick: PropTypes.func.isRequired,
};

export default InfoModal;
